<template>
    <section class="formatter">
        <div class="d-flex gap-5 groups">
            <TimezonePickerInput v-model="clone.isBefore.fromTimezone" title="First Date Timezone" />
            <TimezonePickerInput v-model="clone.isBefore.toTimezone" title="Second Date Timezone" />
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.isBefore.fromFormat" title="First Date Format" />
                <FormatPickerInput v-model="clone.isBefore.toFormat" title="Second Date Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.isBefore.fromLocale" title="First Date Locale" />
            <LocalePickerInput v-model="clone.isBefore.toLocale" title="Second Date Locale" />
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";
import TimezonePickerInput from "../inputs/TimezonePickerInput.vue";

const log = log2("DateIsBefore.vue");
export default {
    name: "DateIsBefore",
    components: { TiptapEditor, FormatPickerInput, LocalePickerInput, TimezonePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.isBefore",
            inputs: ["", ""],
            isBefore: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                toTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en"
            }
        };
        if (!clone.isBefore) {
            clone.isBefore = {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                toTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en",
            };
        }
        return {
            clone
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            }
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section,
        .locale-picker-section,
        .timezone-picker-section {
            width: 100%;
        }
    }
}
</style> 